// skipcq: JS-W1028
import BeenhereOutlinedIcon from '@mui/icons-material/BeenhereOutlined';
import ReviewsOutlinedIcon from '@mui/icons-material/ReviewsOutlined';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

/**
 * @param {unknown} value
 * @returns {number}
 */
function resolveStatCount(value) {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }
  return 0;
}

function BeerProfileSummaryStat({ icon, label, count, ariaLabel }) {
  return (
    <Box
      aria-label={ariaLabel}
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0 }}
    >
      {icon}
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h6" component="p" fontWeight={600}>
          {count}
        </Typography>
      </Box>
    </Box>
  );
}

BeerProfileSummaryStat.propTypes = {
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

function BeerProfileSummaryStatsCard({ totalReviews, checkinsCount }) {
  const reviewCount = resolveStatCount(totalReviews);
  const checkinCount = resolveStatCount(checkinsCount);

  return (
    <Card variant="outlined" sx={{ bgcolor: 'background.paper' }}>
      <CardContent
        sx={{
          p: { xs: 2, sm: 3 },
          '&:last-child': { pb: { xs: 2, sm: 3 } },
        }}
      >
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 2,
          }}
        >
          <BeerProfileSummaryStat
            icon={<ReviewsOutlinedIcon color="action" aria-hidden />}
            label="Reviews"
            count={reviewCount}
            ariaLabel={`Reviews: ${reviewCount}`}
          />
          <BeerProfileSummaryStat
            icon={<BeenhereOutlinedIcon color="action" aria-hidden />}
            label="Times logged"
            count={checkinCount}
            ariaLabel={`Times logged: ${checkinCount}`}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

BeerProfileSummaryStatsCard.propTypes = {
  totalReviews: PropTypes.number,
  checkinsCount: PropTypes.number,
};

export default BeerProfileSummaryStatsCard;
